import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25f7d0ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "citaDetalleModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  ref: "detalleCitaModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header pt-5 pb-3 px-10" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-left fs-2 fw-bold" }, "Detalle de la cita"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-sm btn-icon",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("i", { class: "isax-close-circle text-white fs-2" })
    ])
  ])
], -1))
const _hoisted_5 = {
  key: 0,
  class: "modal-body scroll-y px-10"
}
const _hoisted_6 = { class: "row mb-2" }
const _hoisted_7 = { class: "col-12 text-start" }
const _hoisted_8 = { class: "p-0 lst-none" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "Tipo de cita")
], -1))
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "" }
const _hoisted_12 = {
  key: 0,
  class: "row mb-2"
}
const _hoisted_13 = { class: "col-12 text-start" }
const _hoisted_14 = { class: "p-0 lst-none" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "Estatus")
], -1))
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "row mb-2"
}
const _hoisted_20 = { class: "col-12 text-start" }
const _hoisted_21 = { class: "p-0 lst-none" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "Estatus")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "Pendiente",
  class: "fs-base"
}, "Pendiente", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "Atendida",
  class: "fs-base"
}, "Atendida", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "Cancelada",
  class: "fs-base"
}, "Cancelada", -1))
const _hoisted_26 = { class: "row mb-2" }
const _hoisted_27 = { class: "col-12 text-start" }
const _hoisted_28 = { class: "p-0 lst-none" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "Día")
], -1))
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "isax-calendar-1 text-white fs-base me-5" }, null, -1))
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "row mb-2" }
const _hoisted_34 = { class: "col-12 text-start" }
const _hoisted_35 = { class: "p-0 lst-none" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "Horario")
], -1))
const _hoisted_37 = { class: "d-flex align-items-center" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "isax-clock text-white fs-base me-3" }, null, -1))
const _hoisted_39 = { class: "" }
const _hoisted_40 = { class: "row mb-2" }
const _hoisted_41 = { class: "col-12 text-start" }
const _hoisted_42 = { class: "p-0 lst-none" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "Cliente")
], -1))
const _hoisted_44 = { class: "d-flex align-items-center" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "isax-user text-white fs-base me-5" }, null, -1))
const _hoisted_46 = { class: "" }
const _hoisted_47 = { class: "ms-10" }
const _hoisted_48 = { class: "ms-10" }
const _hoisted_49 = {
  key: 2,
  class: "row mb-2"
}
const _hoisted_50 = { class: "col-12 text-start" }
const _hoisted_51 = { class: "p-0 lst-none" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "Dirección")
], -1))
const _hoisted_53 = { class: "d-flex align-items-center" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "isax-map-1 text-white fs-base me-5" }, null, -1))
const _hoisted_55 = { class: "" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = {
  key: 0,
  class: "ms-10"
}
const _hoisted_58 = { class: "ms-10" }
const _hoisted_59 = { class: "ms-10" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 3 }
const _hoisted_62 = {
  key: 0,
  class: "row mb-2"
}
const _hoisted_63 = { class: "col-12 text-start" }
const _hoisted_64 = { class: "p-0 lst-none" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "Vehículo")
], -1))
const _hoisted_66 = { class: "d-flex align-items-center" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "isax-car text-white fs-base me-5" }, null, -1))
const _hoisted_68 = { class: "" }
const _hoisted_69 = { class: "ms-10" }
const _hoisted_70 = { class: "ms-10" }
const _hoisted_71 = {
  key: 1,
  class: "row mb-2"
}
const _hoisted_72 = { class: "col-12 text-start" }
const _hoisted_73 = { class: "p-0 lst-none" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "Precio cotizado")
], -1))
const _hoisted_75 = { class: "d-flex align-items-center" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "isax-card text-white fs-base me-5" }, null, -1))
const _hoisted_77 = {
  key: 0,
  class: ""
}
const _hoisted_78 = {
  key: 0,
  class: ""
}
const _hoisted_79 = { key: 1 }
const _hoisted_80 = {
  key: 2,
  class: "row mb-2"
}
const _hoisted_81 = { class: "col-12 text-start" }
const _hoisted_82 = { class: "p-0 lst-none" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "Vehículo de interés")
], -1))
const _hoisted_84 = { class: "d-flex align-items-center" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "isax-car text-white fs-base me-5" }, null, -1))
const _hoisted_86 = { class: "" }
const _hoisted_87 = { class: "ms-10" }
const _hoisted_88 = { key: 4 }
const _hoisted_89 = {
  key: 0,
  class: "row mb-2"
}
const _hoisted_90 = { class: "col-12 text-start" }
const _hoisted_91 = { class: "p-0 lst-none" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "Vehículo de interés")
], -1))
const _hoisted_93 = { class: "d-flex align-items-center" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "isax-car text-white fs-base me-5" }, null, -1))
const _hoisted_95 = { class: "" }
const _hoisted_96 = { class: "ms-10" }
const _hoisted_97 = { key: 5 }
const _hoisted_98 = {
  key: 0,
  class: "row mb-2"
}
const _hoisted_99 = { class: "col-12 text-start" }
const _hoisted_100 = { class: "p-0 lst-none" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "Vehículo a tomar a cuenta")
], -1))
const _hoisted_102 = { class: "d-flex align-items-center" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "isax-dollar-circle text-white fs-5 me-5" }, null, -1))
const _hoisted_104 = { class: "" }
const _hoisted_105 = { class: "ms-10" }
const _hoisted_106 = {
  key: 6,
  class: "row mb-2"
}
const _hoisted_107 = { class: "col-12 text-start" }
const _hoisted_108 = { class: "p-0 lst-none" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "Valuador")
], -1))
const _hoisted_110 = { class: "d-flex align-items-center" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "isax-medal text-white fs-base me-5" }, null, -1))
const _hoisted_112 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModalCitaAtendida = _resolveComponent("ModalCitaAtendida")!
  const _component_ModalCitaCancelada = _resolveComponent("ModalCitaCancelada")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (Object.keys(_ctx.detailMeeting).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("ul", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("li", null, [
                        _createElementVNode("img", {
                          src: 
                        _ctx.detailMeeting.tipo_cita.id == 1
                          ? 'media/icons/iconsax/blue_dot.svg'
                          : 'media/icons/iconsax/green_dot.svg'
                      ,
                          class: "dots me-5"
                        }, null, 8, _hoisted_10),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.detailMeeting.tipo_cita.name), 1)
                      ])
                    ])
                  ])
                ]),
                (!_ctx.showSelect)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("ul", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("li", null, [
                            _createElementVNode("img", {
                              src: 
                        typeof _ctx.detailMeeting.status !== 'undefined' &&
                        _ctx.detailMeeting.status.name == 'Pendiente'
                          ? 'media/icons/iconsax/blue_dot.svg'
                          : typeof _ctx.detailMeeting.status !== 'undefined' &&
                            _ctx.detailMeeting.status.name == 'Atendida'
                          ? 'media/icons/iconsax/green_dot.svg'
                          : 'media/icons/iconsax/red_dot.svg'
                      ,
                              class: "dots me-5"
                            }, null, 8, _hoisted_16),
                            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.detailMeeting.status.name), 1)
                          ]),
                          (
                      typeof _ctx.detailMeeting.status !== 'undefined' &&
                      _ctx.detailMeeting.status.name == 'Pendiente'
                    )
                            ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                                _createElementVNode("a", {
                                  class: "link-blue ms-10 fs-sm",
                                  href: "javascript:void(0)",
                                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showSelected && _ctx.showSelected(...args)))
                                }, "Actualizar estatus")
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showSelect)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("ul", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("li", null, [
                            _createVNode(_component_Field, {
                              name: "estatusCita",
                              ref: "estatusCita",
                              as: "select",
                              class: "form-select form-control form-control-sm fs-base fw-normal form-control-solid borderGray",
                              modelValue: _ctx.estatus,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.estatus) = $event)),
                              onChange: _ctx.changeStatus
                            }, {
                              default: _withCtx(() => [
                                _hoisted_23,
                                _hoisted_24,
                                _hoisted_25
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("ul", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("li", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.moment(_ctx.detailMeeting.date).format("dddd DD MMMM YYYY")), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("ul", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("li", _hoisted_37, [
                        _hoisted_38,
                        _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.detailMeeting.horario[0]), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("ul", _hoisted_42, [
                      _hoisted_43,
                      _createElementVNode("li", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.detailMeeting.name) + " " + _toDisplayString(_ctx.detailMeeting.last_name), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.detailMeeting.email), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.detailMeeting.phone), 1)
                      ])
                    ])
                  ])
                ]),
                (_ctx.detailMeeting.tipo_cita.id == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("ul", _hoisted_51, [
                          _hoisted_52,
                          _createElementVNode("li", _hoisted_53, [
                            _hoisted_54,
                            _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.firstCharToUppercase(_ctx.detailMeeting.address)) + " " + _toDisplayString(_ctx.detailMeeting.num_ext), 1),
                            (_ctx.detailMeeting.num_int)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_56, ", interior " + _toDisplayString(_ctx.detailMeeting.num_int), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("li", null, [
                            (_ctx.detailMeeting.entre_calles)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.firstCharToUppercase(_ctx.detailMeeting.entre_calles)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.firstCharToUppercase(_ctx.detailMeeting.colonia)) + ", " + _toDisplayString(_ctx.detailMeeting.cp), 1)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.detailMeeting.city), 1),
                            (_ctx.detailMeeting.state)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_60, ", " + _toDisplayString(_ctx.detailMeeting.state), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.detailMeeting.tipo_cita.id == 1 || _ctx.detailMeeting.tipo_cita.id == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      (Object.keys(_ctx.detailMeeting.vehicle_a_cuenta).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("ul", _hoisted_64, [
                                _hoisted_65,
                                _createElementVNode("li", _hoisted_66, [
                                  _hoisted_67,
                                  _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.detailMeeting.vehicle_a_cuenta[0]["brand"]) + " " + _toDisplayString(_ctx.detailMeeting.vehicle_a_cuenta[0]["model"]) + " " + _toDisplayString(_ctx.detailMeeting.vehicle_a_cuenta[0]["version"]) + " " + _toDisplayString(_ctx.detailMeeting.vehicle_a_cuenta[0]["year"]), 1)
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("span", _hoisted_69, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.formatKm(_ctx.detailMeeting.vehicle_a_cuenta[0]["mileage"])), 1)
                                  ])
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.detailMeeting.vehicle_a_cuenta[0]["owners"]) + " dueños", 1)
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (Object.keys(_ctx.detailMeeting.vehicle_a_cuenta).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                            _createElementVNode("div", _hoisted_72, [
                              _createElementVNode("ul", _hoisted_73, [
                                _hoisted_74,
                                _createElementVNode("li", _hoisted_75, [
                                  _hoisted_76,
                                  (
                          Object.keys(_ctx.detailMeeting.vehicle_a_cuenta[0]['valuation'])
                            .length > 0
                        )
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_77, [
                                        (
                            _ctx.detailMeeting.vehicle_a_cuenta[0]['valuation'][0]['Price'] !=
                              '' &&
                            _ctx.detailMeeting.vehicle_a_cuenta[0]['valuation'][0]['Price'] !=
                              null
                          )
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_78, " $" + _toDisplayString(_ctx.formatPrice(
                              _ctx.detailMeeting.vehicle_a_cuenta[0]["valuation"][0]["Price"]
                            )), 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_79, " $ 0.00 "))
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (Object.keys(_ctx.detailMeeting.vehicle_de_interes).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                            _createElementVNode("div", _hoisted_81, [
                              _createElementVNode("ul", _hoisted_82, [
                                _hoisted_83,
                                _createElementVNode("li", _hoisted_84, [
                                  _hoisted_85,
                                  _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.detailMeeting.vehicle_de_interes[0]["brand"] +
                        " " +
                        _ctx.detailMeeting.vehicle_de_interes[0]["model"] +
                        " " +
                        _ctx.detailMeeting.vehicle_de_interes[0]["version"] +
                        " " +
                        _ctx.detailMeeting.vehicle_de_interes[0]["year"]), 1)
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("span", _hoisted_87, [
                                    _createVNode(_component_router_link, {
                                      class: "link-blue fs-sm",
                                      to: {
                            name: 'vehicles-detail',
                            params: { id: _ctx.detailMeeting.vehicle_de_interes[0]['id'] },
                          }
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Ver detalle")
                                      ]),
                                      _: 1
                                    }, 8, ["to"])
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.detailMeeting.tipo_cita.id == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                      (Object.keys(_ctx.detailMeeting.vehicle_de_interes).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                            _createElementVNode("div", _hoisted_90, [
                              _createElementVNode("ul", _hoisted_91, [
                                _hoisted_92,
                                _createElementVNode("li", _hoisted_93, [
                                  _hoisted_94,
                                  _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.detailMeeting.vehicle_de_interes[0]["brand"] +
                        " " +
                        _ctx.detailMeeting.vehicle_de_interes[0]["model"] +
                        " " +
                        _ctx.detailMeeting.vehicle_de_interes[0]["version"] +
                        " " +
                        _ctx.detailMeeting.vehicle_de_interes[0]["year"]), 1)
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("span", _hoisted_96, [
                                    _createVNode(_component_router_link, {
                                      class: "link-blue fs-sm",
                                      to: {
                            name: 'vehicles-detail',
                            params: { id: _ctx.detailMeeting.vehicle_de_interes[0]['id'] },
                          }
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Ver detalle")
                                      ]),
                                      _: 1
                                    }, 8, ["to"])
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.detailMeeting.tipo_cita.id == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                      (Object.keys(_ctx.detailMeeting.vehicle_a_cuenta).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                            _createElementVNode("div", _hoisted_99, [
                              _createElementVNode("ul", _hoisted_100, [
                                _hoisted_101,
                                _createElementVNode("li", _hoisted_102, [
                                  _hoisted_103,
                                  _createElementVNode("span", _hoisted_104, _toDisplayString(_ctx.detailMeeting.vehicle_a_cuenta[0]["brand"]) + " " + _toDisplayString(_ctx.detailMeeting.vehicle_a_cuenta[0]["model"]) + " " + _toDisplayString(_ctx.detailMeeting.vehicle_a_cuenta[0]["version"]) + " " + _toDisplayString(_ctx.detailMeeting.vehicle_a_cuenta[0]["year"]), 1)
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("span", _hoisted_105, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.formatKm(_ctx.detailMeeting.vehicle_a_cuenta[0]["mileage"])), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.detailMeeting.valuador.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                      _createElementVNode("div", _hoisted_107, [
                        _createElementVNode("ul", _hoisted_108, [
                          _hoisted_109,
                          _createElementVNode("li", _hoisted_110, [
                            _hoisted_111,
                            _createElementVNode("span", _hoisted_112, _toDisplayString(_ctx.detailMeeting.valuador[0].name), 1)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512),
    _createVNode(_component_ModalCitaAtendida, {
      showModal: _ctx.modalAtendida,
      idschedule: _ctx.detailMeeting.id,
      idtypemeeting: 
        typeof _ctx.detailMeeting.tipo_cita !== 'undefined' ? _ctx.detailMeeting.tipo_cita.id : null
      ,
      onCloseAtendida: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeAtendida($event))),
      onCloseSelect: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSelected()))
    }, null, 8, ["showModal", "idschedule", "idtypemeeting"]),
    _createVNode(_component_ModalCitaCancelada, {
      showModal: _ctx.modalCancelada,
      idschedule: _ctx.detailMeeting.id,
      onCloseCancelada: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeCancelada($event))),
      onCloseSelect: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showSelected()))
    }, null, 8, ["showModal", "idschedule"])
  ]))
}